module.exports = __webpack_public_path__ + "static/media/lidar_point_cloud_viewer.dec0c2c9.jpg";